export default __webpack_public_path__ + "static/media/logo-dark.30bd855b.png";